import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/super-admin/login`, { email, password });
      localStorage.setItem('sa_token', res.data.access_token);
      localStorage.setItem('sa_user', JSON.stringify(res.data.user));
      toast.success('Welcome back, Greg!');
      navigate('/super-admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#060B15] flex items-center justify-center px-4" data-testid="super-admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-red-600/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-red-600/20">
            <ShieldCheck size={32} className="text-red-500" weight="duotone" />
          </div>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'Bebas Neue', letterSpacing: '0.05em' }}>
            Super Admin
          </h1>
          <p className="text-sm text-gray-500 mt-1">Track My Package Control Center</p>
        </div>
        <form onSubmit={handleLogin} className="bg-white/[0.03] border border-white/10 rounded-2xl p-8 space-y-5">
          <div>
            <label className="text-xs text-gray-400 font-medium mb-1.5 block">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="bg-white/5 border-white/10 text-white rounded-xl h-12"
              required
              data-testid="sa-email-input"
            />
          </div>
          <div>
            <label className="text-xs text-gray-400 font-medium mb-1.5 block">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="bg-white/5 border-white/10 text-white rounded-xl h-12"
              required
              data-testid="sa-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-red-600 hover:bg-red-700 text-white h-12 rounded-xl font-medium"
            data-testid="sa-login-btn"
          >
            {loading ? 'Signing in...' : 'Access Control Center'}
            <ArrowRight size={16} className="ml-2" />
          </Button>
        </form>
        <p className="text-center text-xs text-gray-600 mt-6">Restricted Access Only</p>
      </div>
    </div>
  );
}
